// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Post_wrapper__csjKt","title":"Post_title__tVvXS","excerpt":"Post_excerpt__eorow","content":"Post_content___Lwh0","metabar":"Post_metabar__GxaXA"};